<template>
  <div>
    <a-modal v-model="modalVisible" :destroy-on-close="true" width="1000px" title="业务需求明细" :footer="false" @cancel="close">
      <a-tabs v-model="activeTab" @change="handleTabChange">
        <a-tab-pane v-for="step in uniqueSteps" :key="step" :tab="`${stepMap[step]} (${getStepCount(step)})`">
          <a-table :columns="columns" size="middle" :data-source="filteredTableData" row-key="id" :loading="loading">
            <div slot="idSlots" slot-scope="text, record">
              {{ `BR-${record.id}` }}
            </div>
            <div slot="titleSlots" slot-scope="text, record">
              <a class="custom-link" :href="link(record)" target="_blank">{{ record.title }}</a>
            </div>
            <div slot="timeCountSlots" slot-scope="text">
              {{ formatTimeCount(text) }}
            </div>
          </a-table>
        </a-tab-pane>
      </a-tabs>
    </a-modal>
  </div>
</template>

<script>
const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 70,
    scopedSlots: { customRender: 'idSlots' }
  },
  {
    title: '需求标题',
    dataIndex: 'title',
    key: 'title',
    width: 200,
    scopedSlots: { customRender: 'titleSlots' }
  },
  {
    title: '耗时',
    dataIndex: 'timeCount',
    key: 'timeCount',
    align: 'center',
    width: 100,
    scopedSlots: { customRender: 'timeCountSlots' }
  }
];

export default {
  components: {},
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      stepMap: {
        135: '需求问答中-待需求方案',
        136: '待需求方案-待开发',
        137: '待开发-开发中',
        138: '开发中-待验收',
        139: '待验收-验收中(天)',
        140: '验收中-已交付(天)'
      },
      modalVisible: false,
      loading: false,
      tableData: [],
      activeTab: null,
      columns
    };
  },
  computed: {
    uniqueSteps() {
      return [...new Set(this.tableData.filter(item => item.afterStep >= 135).map(item => item.afterStep))].sort((a, b) => a - b);
    },
    filteredTableData() {
      if (!this.activeTab) return [];
      return this.tableData.filter(item => item.afterStep === this.activeTab).sort((a, b) => b.timeCount - a.timeCount);
    },
    link() {
      return record => {
        return this.$router.resolve({
          name: 'page:business:requirement:detail',
          params: { id: record.id }
        }).href;
      };
    }
  },
  methods: {
    close() {
      this.modalVisible = false;
    },
    getStepCount(step) {
      return this.tableData.filter(item => item.afterStep === step).length;
    },
    formatTimeCount(seconds) {
      const days = Math.floor(seconds / (24 * 60 * 60));
      return `${days}天`;
    },
    open(tableData) {
      this.modalVisible = true;
      this.tableData = tableData;
      if (this.uniqueSteps.length > 0) {
        this.activeTab = this.uniqueSteps[0];
      }
    },
    handleTabChange(key) {
      this.activeTab = key;
    }
  }
};
</script>

<style scoped>
:deep(.ant-tabs-nav) {
  margin-bottom: 8px;
}

:deep(.ant-tabs-tab) {
  margin-right: 8px !important;
  padding: 8px 16px !important;
}
</style>
